import { Category } from '../../types';
import { categoryColor } from '../../utils/categoryColors';
import styles from './CategoryBadge.module.css';

interface CategoryBadgeProps {
  category: Category;
}

export function CategoryBadge({ category }: CategoryBadgeProps) {
  const color = categoryColor[category];
  return (
    <span
      className={styles.badge}
      style={{ color, borderColor: `${color}40`, background: `${color}10` }}
    >
      {category}
    </span>
  );
}
